(function(){
  const desNavbarContainer = document.querySelector(".des-navbar-container");
  if(!desNavbarContainer) return;
  desNavbarContainer.addEventListener("click", (event) => {
    event.preventDefault();
    if (event.target.tagName !== "BUTTON" || !event.target.name) return;
  
    const targetSection = document.querySelector(`[data-section-observed-name=${event.target.name}]`);
    if (!targetSection) return;
    const isMainProductSection = targetSection.parentElement.id.includes('MainProduct');
    if(isMainProductSection) {
      targetSection.scrollIntoView({behavior: 'smooth'})
    } else {
      // console.log('targetSection', targetSection, 'offsetTop', targetSection.offsetTop, 'navbar height', desNavbarContainer.offsetHeight, 'parentElement offsettop value', targetSection.parentElement.offsetTop, 'main offsetTop value', document.querySelector('main').offsetTop);
      const extraHeightValue = document.body.clientWidth > 990 ? document.querySelector('main').offsetTop : 0;
      window.scrollTo({
        top: targetSection.parentElement.offsetTop  - desNavbarContainer.offsetHeight + extraHeightValue,
        behavior: "smooth",
      });
    }
  });
  
  // Intersectionobserver
  const observeWindowStart = -window.visualViewport.height / 3;
  const observeWindowEnd = -window.visualViewport.height * 2 / 3;
  // console.log('observeWindowStart', observeWindowStart, 'observeWindowEnd', observeWindowEnd + 10);
  
  const desSectionObserver = new IntersectionObserver(highlightNavButton, {rootMargin: `${observeWindowStart}px 0px ${observeWindowEnd + 10}px 0px`});
  // console.log("desSectionObserver", desSectionObserver);
  
  function highlightNavButton(entries) {
    entries.forEach(entry => {
      // console.log('entry.target', entry.target);
      const section = entry.target.querySelector('.section__observed');
      if(!section) return;
      const name = section.dataset.sectionObservedName.toLowerCase();
      const button = desNavbarContainer.querySelector(`[name=${name}]`);
      if(button) button.classList.toggle('active', entry.isIntersecting);
    })
  }
  
  const observedSections = document.querySelectorAll(".description-section__observed");
  
  observedSections.forEach((section) => {
    desSectionObserver.observe(section);
  });
})()
